"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const defaultRelayHubConfiguration = {
    gasOverhead: 36660,
    postOverhead: 11840,
    gasReserve: 100000,
    maxWorkerCount: 10,
    minimumStake: 1e18.toString(),
    minimumUnstakeDelay: 1000,
    maximumRecipientDeposit: 2e18.toString()
};
exports.environments = {
    istanbul: {
        chainId: 1,
        relayHubConfiguration: defaultRelayHubConfiguration,
        mintxgascost: 21000
    },
    constantinople: {
        chainId: 1,
        relayHubConfiguration: defaultRelayHubConfiguration,
        mintxgascost: 21000
    }
};
exports.defaultEnvironment = exports.environments.istanbul;
//# sourceMappingURL=Environments.js.map